import React from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';
import './Actions.scss';

const cbn = 'ui-form-actions';

function UIFormActions({ children }) {
  return <div className={cbn}>{children}</div>;
}

UIFormActions.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
};

UIFormActions.defaultProps = {
  children: null,
};

export default UIFormActions;
